
import { BefDataAdapterWhereObject, BefWhereControls, BefWhereType } from "@beflam/bef-core";
import dayjs, { Dayjs } from "dayjs";



export const SelectCollection = [
    { "key": "等于", "value": 0 },
    { "key": "大于", "value": 1 },
    { "key": "大于等于", "value": 2 },
    { "key": "小于", "value": 3 },
    { "key": "小于等于", "value": 4 },
    { "key": "不等于", "value": 5 },
    { "key": "相似", "value": 6 },
    { "key": "包括", "value": 7 },
    { "key": "不包括", "value": 8 },
    { "key": "空值", "value": 9 },
    { "key": "不相似", "value": 10 },
    { "key": "空字符串", "value": 11 },
    { "key": "表达式", "value": 99 }
];

export const isDateType = (dataType: string) => {
    return dataType === 'date' || dataType === 'datetime' || dataType === 'time';
}
export const getDayjs = (val: any) => {
    if (val == null) return null;
    return dayjs(val);
};
export const toWhere = (schema: any): BefDataAdapterWhereObject[] => {
    var result: BefDataAdapterWhereObject[] = [];
    if (schema == null) return result;
    for (const data of schema) {
        if (!data) continue;
        const field = data.id;
        if (!field) continue;
        //    const fieldDesc = pageService?.getLanguage ? pageService.getLanguage(field) : field;

        // const fValue = data.fValueField ? _dataSource[data.fValueField] : null;
        // const lValue = data.lValueField ? _dataSource[data.lValueField] : null;
        // const controlChar = data.controlCharField ? _dataSource[data.controlCharField] : null;
        const fValue = data.fValueField != null && data.fValueField !== '' ? data.fValueField : null;
        const lValue = data.lValueField != null && data.lValueField !== '' ? data.lValueField : null;
        const controlChar = data.controlCharField != null && data.controlCharField !== '' ? data.controlCharField : null;
        // if (data.required) {
        //     if ((fValue == null || fValue.toString().length === 0) && (lValue == null || lValue.toString().length === 0)) throw `${fieldDesc}不可为空`;
        // }

        if ((fValue == null || String(fValue).trim().length === 0) && (lValue == null || String(lValue).trim().length === 0)) continue;

        let control: BefWhereControls = BefWhereControls.equalTo;
        let fVal = fValue;
        let lVal = lValue;
        if (!isNaN(controlChar)) {
            if (controlChar === BefWhereType.空字符串) {
                result.push(new BefDataAdapterWhereObject(field, fVal == "false" ? BefWhereControls.notEqualTo : BefWhereControls.equalTo, ""));
                continue;
            } else {
                control = Number(controlChar);
            }
        }
        let fDayjs: any = null;
        let lDayjs: any = null;
        if (isDateType(data.dataType)) {
            fDayjs = getDayjs(fVal);
            lDayjs = getDayjs(lVal);
        }
        const isFDate = fDayjs != null && fDayjs.isValid();
        const isLDate = lDayjs != null && lDayjs.isValid();
        if (isFDate || isLDate) {
            if (control === BefWhereControls.equalTo) {
                if (isFDate && isLDate) {
                    let fDate = fDayjs.toDate();
                    let lDate = lDayjs.toDate();
                    if (lDate.getHours() === 0 && lDate.getMinutes() === 0 && lDate.getSeconds() === 0) {
                        lDate = new Date(lDate.getFullYear(), lDate.getMonth(), lDate.getDate(), 23, 59, 59);
                    }
                    result.push(new BefDataAdapterWhereObject(field, BefWhereControls.greaterThanOrEqual, dateFormat("YYYY-MM-DD HH:mm:ss", fDate)));
                    result.push(new BefDataAdapterWhereObject(field, BefWhereControls.lessThanOrEqual, dateFormat("YYYY-MM-DD HH:mm:ss", lDate)));
                } else if (isFDate) {
                    let fDate = fDayjs.toDate();
                    let lDate: Date;
                    if (fDate.getHours() !== 0 || fDate.getMinutes() !== 0 || fDate.getSeconds() !== 0) {
                        lDate = new Date(fDate.getFullYear(), fDate.getMonth(), fDate.getDate(), fDate.getHours(), fDate.getMinutes(), 59);
                    } else {
                        lDate = new Date(fDate.getFullYear(), fDate.getMonth(), fDate.getDate(), 23, 59, 59);
                    }
                    result.push(new BefDataAdapterWhereObject(field, BefWhereControls.greaterThanOrEqual, dateFormat("YYYY-MM-DD HH:mm:ss", fDate)));
                    result.push(new BefDataAdapterWhereObject(field, BefWhereControls.lessThanOrEqual, dateFormat("YYYY-MM-DD HH:mm:ss", lDate)));
                } else {
                    let lDate = lDayjs.toDate();
                    if (lDate.getHours() === 0 && lDate.getMinutes() === 0 && lDate.getSeconds() === 0) {
                        lDate = new Date(lDate.getFullYear(), lDate.getMonth(), lDate.getDate(), 23, 59, 59);
                    }
                    result.push(new BefDataAdapterWhereObject(field, BefWhereControls.lessThanOrEqual, dateFormat("YYYY-MM-DD HH:mm:ss", lDate)));
                }
            } else if (isFDate) {
                let fDate = fDayjs.toDate();
                result.push(new BefDataAdapterWhereObject(field, control, dateFormat("YYYY-MM-DD HH:mm:ss", fDate)));
            }
        } else {
            switch (control) {
                case BefWhereControls.equalTo: {
                    if (fVal != null && String(fVal).trim().length > 0 && lVal != null && String(lVal).trim().length > 0) {
                        result.push(new BefDataAdapterWhereObject(field, BefWhereControls.greaterThanOrEqual, fVal));
                        result.push(new BefDataAdapterWhereObject(field, BefWhereControls.lessThanOrEqual, lVal));
                    } else if (fVal != null && String(fVal).trim().length > 0) {
                        result.push(new BefDataAdapterWhereObject(field, control, fVal));
                    } else {
                        result.push(new BefDataAdapterWhereObject(field, BefWhereControls.lessThanOrEqual, lVal));
                    }
                    break;
                }
                case BefWhereControls.like:
                case BefWhereControls.notLike: {
                    result.push(new BefDataAdapterWhereObject(field, control, `*${String(fVal).trim()}*`));
                    break;
                }
                default: {
                    if (fVal != null && String(fVal).trim().length > 0) {
                        result.push(new BefDataAdapterWhereObject(field, control, fVal));
                    }
                    break;
                }
            }
        }
    }
    return result;
}

export const dateFormat = (_format: string, date: any) => {
    return dayjs(date).format(_format);

}